import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogDetailPage } from '@/features/data/catalog/catalog-detail-page';
import { catalogSearch } from '@/features/data/catalog/catalog-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Une base : ses tables (onglet par défaut), son résumé, sa définition. */
export const Route = createFileRoute('/$tenant/catalog/$layer/$database/')({
  validateSearch: catalogSearch,
  component: DatabaseRoute,
});

function DatabaseRoute() {
  const { tenant, layer, database } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[
        { label: t('nav.items.catalog') },
        { label: layer, mono: true },
        { label: database, mono: true },
      ]}
    >
      <CatalogDetailPage
        tenantId={tenant}
        path={{ level: 'database', layer, database }}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
